export enum EventType {
  Opening = 'OPENING',
  Appointment = 'APPOINTMENT',
  Hold = 'HOLD',
  Block = 'BLOCK',
  Intake = 'INTAKE',
  Verification = 'VERIFICATION',
  GoogleEvent = 'GOOGLE_EVENT',
}

export enum AppointmentType {
  InPerson = 'INTAKE_IN_PERSON',
  Telehealth = 'INTAKE_ONLINE',
}

export enum RepeatType {
  Never = 'NEVER',
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
}

export enum EndAfterType {
  Never = 'never',
  Count = 'count',
  Until = 'until',
}

export enum PatientAge {
  AnyAge = 'Any Age',
  Adult = 'Adult',
  Minor = 'Minor',
}

export enum PatientType {
  NewPatient = 'New Patient',
}

export enum FormFields {
  EventType = 'event_type',
  TherapistName = 'therapist_name',
  ServiceTypes = 'service_types',
  PatientAge = 'patient_age',
  MeetingPreference = 'meeting_pref',
  StartDateTime = 'start_date_time',
  Duration = 'duration',
  OfficeLocation = 'office_location',
  TherapistId = 'therapist_id',
  AllDayEvent = 'allDayEvent',
  Recurring = 'recurring',
  Repeat = 'repeat',
  Room = 'room',
  RepeatEvery = 'repeat_every',
  RepeatDays = 'repeat_days',
  Until = 'until',
  RepeatEndAfter = 'repeat_end_after',
  RRule = 'r_rule',
  UpdatedRRule = 'updated_r_rule',
  NewRRule = 'new_r_rule',
  UpdateScope = 'update_scope',
  SeriesId = 'series_id',
  EventId = 'eventId',
  EndCount = 'endCount',
  DoNotRemoveOtherOpeningsOnBooking = 'do_not_remove_other_openings_on_booking',
}
// This empty export makes the file a module
export {};
